import React, { useState, useEffect } from "react";
import "./Home.css";
import { getStoredData } from "../../api/fetchData.jsx";
import AdminMenu from "../../components/AdminMenu/AdminMenu";
import AdminFunctions from "../../components/AdminFunctions/AdminFunctions";

const Home = () => {
  const menuItems = getStoredData()?.[0].Dashboard;
  const Function = getStoredData()?.[0].Functions;

  return (
    <div className="admin-dashboard">
      <AdminMenu menuItems={menuItems} /> 
      <AdminFunctions functions={Function}/>
    </div>
  );
};

export default Home;